<div class="loader-wrapper" [class.hidden]="!isLoading">
    <div class="loader"></div>
</div>

<style>

.loader-wrapper {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, .4);
  z-index: 1000;
  transition: opacity .2s ease-in;
}

.loader {
  position: absolute;
  top: 45%;
  left: 45%;
  transform: translate(-50%, -50%);
  border: 6px solid #f3f3f3;
  border-radius: 50%;
  border-top: 6px solid #3498db;
  width: 80px;
  height: 80px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>